import { apiFetch } from './client';
import type { Role } from './auth';
import type { TabId } from '../tabs';

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  picture?: string;
  role: Role;
  tabs: TabId[];
  sections: string[];
  managerId: string | null;
  lastLoginAt: string | null;
  createdAt: string;
}

export function listUsers(signal?: AbortSignal) {
  return apiFetch<{ users: AdminUser[] }>('/api/users', { signal });
}

export function updateUser(id: string, body: { role?: Role; tabs?: TabId[]; sections?: string[]; managerId?: string | null }) {
  return apiFetch<{ user: AdminUser }>(`/api/users/${id}`, { method: 'PATCH', body });
}

export function deleteUser(id: string) {
  return apiFetch<{ ok: true }>(`/api/users/${id}`, { method: 'DELETE' });
}
